<template>
  <div class="d-none"></div>
</template>

<script>
import { Computed } from '@/_typedefs'
import { createNamespacedHelpers } from 'vuex'
import hypothesisFn from './hypothesis'

const { mapMutations: newAttendanceFormMutations, mapGetters: newAttendanceFormGetters } =
  createNamespacedHelpers('newAttendanceForm')

export default {
  name: 'HypothesisParameter',
  data() {
    return {
      /** @type {Function?} */
      unwatch: null,
    }
  },
  methods: {
    ...newAttendanceFormMutations(['updateParameter']),
  },
  created() {
    this.unwatch = this.$store.subscribe((mutation, state) => {
      if (mutation.type !== 'newAttendanceForm/updateAnswer') {
        return
      }

      const hypothesis = hypothesisFn(
        state.newAttendanceForm.answers,
        state.newAttendanceForm.patientData,
        state.newAttendanceForm.version,
      )
      if (!hypothesis) {
        return
      }
      this.updateParameter({ parameter: 'asthma:hypothesis', value: { score: null, label: hypothesis, hidden: true } })
    })
  },
  beforeDestroy() {
    this.unwatch?.()
  },
}
</script>

<style></style>
